import { z } from "zod";

export const RegisterPushNotificationsDeviceOutputSchema = z.object({
	success: z.boolean(),
});

export type RegisterPushNotificationsDeviceOutputType = z.infer<
	typeof RegisterPushNotificationsDeviceOutputSchema
>;
